import { Injectable } from '@angular/core';
import { PlotObject } from '../asp/PlotObject';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { AroPlotComponent } from './aro-plot.component';

@Injectable({
  providedIn: 'root'
})
export class AroPlotService {

  private dialogRef: MatDialogRef<any>;

  private dialogRefArr: MatDialogRef<any>[] = [];

  constructor(private dialog: MatDialog) { }

  showPlot(plot: PlotObject) {
    this.dialogRef = this.getFromArr(plot.plotID);
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let plotComp = this.dialogRef.componentInstance as AroPlotComponent;
      plotComp.setPlot(plot);
      plotComp.dialogRaise();
    }
    else{
      this.dialogRef = this.dialog.open(AroPlotComponent, AroPlotComponent.createDialogConfig(plot));
      this.dialogRefArr.push(this.dialogRef);
      let plotComp = this.dialogRef.componentInstance as AroPlotComponent;
      plotComp.setPlot(plot);
      plotComp.dialogRaise();
    }
  }

  getFromArr(num: number): any {
    let Ref: MatDialogRef<any> = null;
    this.removeGarbage();
    this.dialogRefArr.forEach((ref) => {
      let refPlotAro = ref.componentInstance as AroPlotComponent;
      if (refPlotAro) {
        if (num == refPlotAro.plotId) {
          Ref = ref;
          return;
        }
      }
    })
    return Ref;
  }

  removeGarbage() {
    this.dialogRefArr = this.dialogRefArr.filter(ele => {
      return(ele != null && ele !== undefined && ele.getState() != MatDialogState.CLOSED);
    })
  }
}
